import { render, staticRenderFns } from "./buttonSetup.vue?vue&type=template&id=18a451c6&scoped=true&"
import script from "./buttonSetup.vue?vue&type=script&lang=js&"
export * from "./buttonSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a451c6",
  null
  
)

export default component.exports